import File from './file';
import MapTitle from './maptitle';
import MapOrder from './maporder';

export default {
  File,
  MapTitle,
  MapOrder,
};
